import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { get, size } from 'lodash-es';
import { toast } from 'react-toastify';
import Table from '../../components/Table';
import Loading from '../../components/Loading';
import CollapseButton from '../../components/CollapseButton';
import { API_HOST } from '../../consts';

class PedidosTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.startCollapsed,
      fetchingElaboradores: true,
      elaboradores: [],
      entregas: [],
      data: {}
    };
  }

  componentDidMount() {
    const { collapsed } = this.state;
    if (!collapsed) {
      this.fetchElaboradores();
    }
  }

  componentDidUpdate(_, prevState) {
    const { collapsed } = this.state;
    if (prevState.collapsed && !collapsed) {
      this.fetchElaboradores();
    }
  }

  get columns() {
    const { handleVerMais } = this.props;
    const statuses = get(this.state, 'data.statuses', []);
    return [
      {
        Header: 'Nome',
        accessor: 'nome'
      },
      {
        Header: 'Dificuldade',
        width: 85,
        accessor: 'dificuldade'
      },
      {
        Header: 'Tipo',
        accessor: 'tipo'
      },
      {
        Header: 'Solicitados',
        width: 80,
        accessor: 'quantidade'
      },
      ...statuses.map((status) => ({
        Header: status.descricao,
        width: 85,
        accessor: `statuses.${status.id}`,
        Cell: (row) => row.value || 0
      })),
      {
        Header: 'Novo Objeto de Aprendizagem',
        width: 280,
        filterable: false,
        Cell: (row) => (
          <>
            <button
              onClick={() => this.handleNovoItem(row)}
              className="btn primary-button ml-2"
            >
              <span>
                <i className="fas fa-plus" style={{ marginRight: '0.5rem' }} />{' '}
                Adicionar Objeto de Aprendizagem
              </span>
            </button>
          </>
        )
      },
      {
        Header: 'Ações',
        filterable: false,
        Cell: (row) => (
          <button onClick={() => handleVerMais(row)} className="btn btn-white">
            <i className="fas fa-eye" />
          </button>
        )
      }
    ];
  }

  get pageSize() {
    const length = get(this.state, 'data.elaboradores.length');
    const maxPageSize = 20;
    return length > maxPageSize ? maxPageSize : length;
  }

  get itensSolicitados() {
    const elaboradores = get(this.state, 'data.elaboradores', []);
    return elaboradores.reduce((acc, el) => acc + el.quantidade || 0, 0);
  }

  get itensEntregues() {
    const elaboradores = get(this.state, 'data.elaboradores', []);
    return elaboradores.reduce(this.reduceItensEntregues, 0);
  }

  reduceItensEntregues(acc, el) {
    const statuses = { ...get(el, 'statuses', {}) };
    delete statuses[1];
    return (
      acc + Object.values(statuses).reduce((acc2, value) => acc2 + value, 0)
    );
  }

  fetchElaboradores() {
    const { pedido } = this.props;
    axios
      .get(`${API_HOST}/encomenda/itens_por_status/elaborador`, {
        params: {
          pedido: get(pedido, 'id')
        }
      })
      .then((response) => {
        this.setState({ data: response.data, fetchingElaboradores: false });
      });

    this.fetchItensVinculados();
  }

  fetchItensVinculados() {
    const { pedido, getItensVinculados } = this.props;
    axios
      .get(`${API_HOST}/encomenda/item`, { params: { pedido: pedido.id } })
      .then((response) => {
        const itensVinculados = response.data.map((d) => d.id);
        getItensVinculados(itensVinculados);
      });
  }

  handleCollapse = () => {
    const { collapsed } = this.state;
    this.setState({ collapsed: !collapsed });
  };

  handleNovoItem = (row) => {
    const { history, pedido } = this.props;
    this.setState({ handlingNovoItem: true });
    console.log(row);
    axios
      .post(`${API_HOST}/encomenda/pedido/${pedido.id}/item`, {
        dificuldade: row.original.dificuldade,
        tipo: row.original.tipo
      })
      .then((response) => {
        history.push(`/itens/${response.data.id}/dados`);
        this.setState({ handlingNovoItem: false });
      })
      .catch((error) => {
        if (get(error, 'response.status') === 403) {
          toast.error(get(error, 'response.data.detail'));
        } else {
          toast.error('Erro ao criar novo objeto de aprendizagem.');
        }
        this.setState({ handlingNovoItem: false });
      });
  };

  render() {
    const { data, fetchingElaboradores, collapsed } = this.state;
    const { elaboradores } = data;
    const { pedido, handleVincularItens } = this.props;

    return (
      <Fragment key={get(pedido, 'id')}>
        <div className="container">
          <div className="professores-first">
            <div className="row">
              <div className="col-5">
                <p className="subtitle">Matriz de Referência</p>
                <p>{get(pedido, 'matriz_referencia.descricao') || '-'}</p>
              </div>
              <div className="col-6">
                <p className="subtitle">Habilidade</p>
                <p>
                  {get(pedido, 'habilidade.cd_habilidade') || '-'} -{' '}
                  {get(pedido, 'habilidade.ds_habilidade')}
                </p>
              </div>
              <div className="col-1">
                <CollapseButton
                  collapsed={collapsed}
                  onClick={this.handleCollapse}
                />
              </div>
            </div>
            {!collapsed && fetchingElaboradores && <Loading />}
            {!collapsed && !fetchingElaboradores && (
              <Fragment>
                <hr />
                <div className="row">
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%'
                    }}
                  >
                    <div className="col-md-8">
                      <button
                        className="btn primary-button"
                        onClick={handleVincularItens}
                      >
                        VINCULAR OBJETOS
                      </button>
                    </div>
                    <div>
                      <p className="subtitle">
                        Objetos de aprendizagem Solicitados:
                      </p>
                      <p>{this.itensSolicitados}</p>
                    </div>
                    <div style={{ marginLeft: 10 }}>
                      <p className="subtitle">
                        Objetos de aprendizagem Entregues:
                      </p>
                      <p>{this.itensEntregues}</p>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <Table
                      showPageSizeOptions={false}
                      pageSize={size(elaboradores)}
                      filterable
                      data={elaboradores}
                      columns={this.columns}
                    />
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

PedidosTab.propTypes = {
  pedido: PropTypes.shape({
    id: PropTypes.number
  }).isRequired,
  startCollapsed: PropTypes.bool,
  handleVincularItens: PropTypes.func.isRequired,
  handleVerMais: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

PedidosTab.defaultProps = {
  startCollapsed: true
};

export default withRouter(PedidosTab);
